var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 14C23 14.5523 22.5523 15 22 15L15 15C14.4477 15 14 14.5523 14 14C14 13.4477 14.4477 13 15 13L22 13C22.5523 13 23 13.4477 23 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 10C23 10.5523 22.5523 11 22 11L15 11C14.4477 11 14 10.5523 14 10C14 9.44771 14.4477 9 15 9L22 9C22.5523 9 23 9.44772 23 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 18C23 18.5523 22.5523 19 22 19L15 19C14.4477 19 14 18.5523 14 18L14 6C14 5.44771 14.4477 5 15 5L22 5C22.5523 5 23 5.44772 23 6L23 18ZM21 17L21 7L16 7L16 17L21 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.50249V19.4975L14 21.7385V2.2615L3 4.50249ZM1.80388 2.66856C1.33646 2.76379 1 3.18185 1 3.66741V20.3326C1 20.8182 1.33646 21.2362 1.80388 21.3314L14.8039 23.9799C15.4227 24.1059 16 23.6238 16 22.981V1.01898C16 0.376173 15.4227 -0.105937 14.8039 0.0201272L1.80388 2.66856Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15L9.54717 11.8971L11.8491 9H9.83019L8.5283 10.7314L7.20755 9H5.10377L7.40566 11.9657L5 15H7.13208L8.48113 13.14L9.84906 15H12Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.ba46fe4719a65c33ea65af7b2092118a.svg";
export { ForwardRef as ReactComponent };